import React, { Component } from 'react';
import { EntityList } from '../../../components/EntityList';
import {withRouter } from 'react-router-dom';

class TodoList extends Component {

    constructor() {
        super();
    }

    render() {        
        return <EntityList
        title={{"pt-BR": "Conciliações Pendentes", "en-US": "Pending Conciliations"}}
        module="conciliation"
        entity="periods"
        columns={["customer", "start_date", "end_date"]}
        filters={["status=PENDING"]}
        permission="CONCILIATION:VIEW_PENDING_PERIODS"
        onRowEdit={(data) => this.props.history.push(`../conciliation/periods/${data.id}`)}
        />
    }
}

export default withRouter(TodoList);